import { render, staticRenderFns } from "./MangelListe.vue?vue&type=template&id=46b8c1a7&"
import script from "./MangelListe.vue?vue&type=script&lang=ts&"
export * from "./MangelListe.vue?vue&type=script&lang=ts&"
import style0 from "./MangelListe.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports